import { render, staticRenderFns } from "./TooManyCardsDialog.vue?vue&type=template&id=cb40d548&scoped=true"
import script from "./TooManyCardsDialog.vue?vue&type=script&lang=js"
export * from "./TooManyCardsDialog.vue?vue&type=script&lang=js"
import style0 from "./TooManyCardsDialog.vue?vue&type=style&index=0&id=cb40d548&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb40d548",
  null
  
)

export default component.exports